import { ACTIONS } from '../ActionTypes';

// Update current user information
export const updateCurrentUserInfo = (fieldKey: string, value: any) => ({
  type: ACTIONS.AUTH.UPDATE_CURRENT_USER_INFO,
  payload: { [fieldKey]: value }
});
